import ApiRequests from "../apiRequests";

class PasswordResetService extends ApiRequests {
  constructor() {
    super("password");
  }
}

export default PasswordResetService;
